import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import Input from 'components/Input';
import Button from 'components/Button';

import CIFields from './CIFields';

import TestSelectionDropdown from './TestSelectionDropdown';

import {
  ParameterDropdown,
  ParameterLevelDropdown
} from 'components/Dropdown';

import { numberOfSamplesValidator } from 'utilities/validators';

const SettingsFormComponent = props => (
  <div className="content-item" id="settings-form">
    <h2 className="header-page">
      Settings
    </h2>

    <ParameterDropdown form={props.form} id="parameter-dropdown" />

    {props.parameterLevels &&
      <ParameterLevelDropdown
        id="parameter-level-dropdown"
        levels={props.parameterLevels}
      />
    }

    {props.optionsControlsVisible &&
      <div>
        <TestSelectionDropdown id="test-selection-dropdown" />

        {props.samplesExist &&
          <CIFields />
        }

        <Field
          min={2}
          max={10000}
          type="number"
          pattern="\d+"
          component={Input}
          id="number-of-samples"
          name="numberOfSamples"
          validate={numberOfSamplesValidator}
          label="Number of Samples (from 2 to 10000)"
        />

        <Field
          min={1}
          type="number"
          pattern="\d+"
          id="sample-size"
          name="sampleSize"
          component={Input}
          label="Sample Size"
          max={props.maxSampleSize}
          validate={props.sampleSizeValidator}
        />

        <div className="flex mb-15">
          <Button
            submit
            className="main-button--green mr-10"
            onClick={props.onGenerateSamplesClick}
            disabled={props.generateSamplesButtonDisabled}
          >

            Generate Samples
          </Button>

          <Button
            reset
            onClick={props.onResetClick}
            className="main-button--grey"
          >

            Reset
          </Button>
        </div>

        {props.showEmptyDatasetWarning &&
          <span className="opacity-50 text-center">
            Your dataset is currently empty, please remove a
            few filters or select a new dataset before continuing.
          </span>
        }
      </div>
    }
  </div>
);

SettingsFormComponent.propTypes = {
  parameterLevels: PropTypes.array,
  form: PropTypes.string.isRequired,
  samplesExist: PropTypes.bool.isRequired,
  maxSampleSize: PropTypes.number.isRequired,
  sampleSizeValidator: PropTypes.func.isRequired,
  optionsControlsVisible: PropTypes.bool.isRequired,
  generateSamplesButtonDisabled: PropTypes.bool.isRequired,

  onResetClick: PropTypes.func.isRequired,
  onGenerateSamplesClick: PropTypes.func.isRequired,
  showEmptyDatasetWarning: PropTypes.bool.isRequired
};

SettingsFormComponent.defaultProps = {
  parameterLevels: null
};

export default SettingsFormComponent;
